import template from './addRoleModal.html';
import controller from './addRoleModal.controller';

let AddRoleModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

export default AddRoleModalComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/modals/addRoleModal/addRoleModal.component.js